<template>
    <div class="ly-button-time">
        <el-button type="success" size="small" icon="edit" @click="openDialog">
            {{title}}
        </el-button>
        <el-dialog :title="title" :visible.sync="dialogVisible" size="tiny" class="ly-button-time__dialog">
            <el-form label-position="top">
                <el-form-item label="请选择日期">
                    <el-date-picker
                        v-model="datepicker"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        style="width:100%;"
                        @change="updateValue">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="提示" class="mt15">
                    <p class="lh18">{{title}}后，系统会将本单据的单号自动排到所选日期的最后一张。</p>
                    <p class="lh18 mt10">假设1月2日最后一张单据为77，修改本单为1月2月后，单号会变为2018-01-02-00078。</p>
                    <p class="lh18 mt10">假如此时再新开1月2日单据，则会从79开始自动编号。</p>
                </el-form-item>
            </el-form>
            <template slot='footer'>
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'LyButtonTime',
        props: {
            infoid: [String, Number],
            date: String, // 初始化得时间
            type: Number, // type标识单据类型
            title: {
                type: String,
                default: '修改单据时间'
            }
        },
        data () {
            return {
                api: 'api/updatetime',
                dialogVisible: false,
                datepicker: '',
                datepickerValue: ''
            }
        },
        created () {
            this.datepicker = this.datepickerValue = this.date
        },
        methods: {
            openDialog () {
                this.dialogVisible = true
            },
            updateValue: function (value) {
                console.log('value:',value)
                if (this.datepickerValue !== value) {
                    this.datepickerValue = value
                }
            },
            submitForm () {
                let data = {}
                if (this.title === '修改业务日期') {
                    data = {
                        id: this.infoid,
                        type: this.type,
                        business_time: this.datepickerValue,
                        work_time: ''
                    }
                } else {
                    data = {
                        id: this.infoid,
                        type: this.type,
                        work_time: this.datepickerValue
                    }
                }
                if (this.datepickerValue && this.datepickerValue.length > 0) {
                    this.$api.create(this.api, data).then((rs) => {
                         this.$message({
                            message: '时间修改成功',
                            type: 'success'
                        })
                        this.dialogVisible = false
                        this.$emit('timeUpdate')
                    }).catch((err) => {
                        this.$message({
                            message: err,
                            type: 'warning'
                        })
                    })
                } else {
                    this.$message({
                        message: '请选择日期',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>
<style>
    .ly-button-time {
        display: inline-block;
        margin-right: 10px;
    }
    .ly-button-time__dialog {
        text-align: left;
    }
</style>